import gtm from '@/utils/gtm';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import EfImgVideo from '../ef-img-video';
import './index.scss';

export interface EfCardListItemProps {
    /**
     * 图片/视频相关
     */
    isVideo?: boolean;
    pc: string;
    h5?: string;
    poster?: string;
    posterH5?: string;
    /**
     * 标题
     */
    title?: string;
    /**
     * 链接或锚点
     */
    href?: string;
    /**
     * 描述
     */
    description?: string | React.ReactNode;
    /**
     * 埋点-锚点到达处的主标题(不传则不会触发埋点)
     */
    gtm_position?: string;
}
interface EfCardListProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 列表
     */
    list: EfCardListItemProps[];

    /**
     * 左右滑动 or 平铺
     */
    isSwiper?: boolean;
}

/**
 * 维护:杨柏迪
 *
 */
const EfCardList: React.FC<EfCardListProps> = ({ list = [], className, isSwiper = true }) => {
    const prefixCls = `ef-card-list`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
    });

    // 点击链接
    const linkHandle = (item: any) => {
        if (item.gtm_position) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: item.gtm_position,
                button_name: item.title,
            });
        }
    };

    return (
        <div className={classes}>
            <div className={`${prefixCls}-wrapper ${!!isSwiper ? `${prefixCls}-wrapper-swiper` : `${prefixCls}-wrapper-list`}   `}>
                {list.map((item, index) => (
                    <a
                        href={item.href || undefined}
                        key={index}
                        className={`${prefixCls}-item`}
                        onClick={() => {
                            linkHandle(item);
                        }}
                    >
                        <div className={`${prefixCls}-item-bg`}>
                            <EfImgVideo
                                isVideo={item?.isVideo}
                                pc={item?.pc}
                                h5={item?.h5 || item?.pc}
                                poster={item?.poster}
                                posterH5={item?.posterH5 || item?.poster}
                                autoPlay={false}
                                loop={false}
                            />
                        </div>
                        <div className={`${prefixCls}-item-content`}>
                            <p className={`${prefixCls}-item-title`}>{item?.title}</p>
                            <div key={index} className={`${prefixCls}-item-desc`}>
                                {item?.description}
                            </div>
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default EfCardList;
